import _ from 'lodash'

const getters = {
  authenticated (state) {
    return state.authenticated
  },

  canInvest (state) {
    const { hasVerifiedEmail, hasPassedAppropriateness, hasPassedKyc } = state.auth.user

    return hasVerifiedEmail && hasPassedAppropriateness && hasPassedKyc
  },

  hasAmlTaken (state) {
    return _.get(state, 'profile.verifications.amlTaken')
  },

  hasAmlPending (state) {
    return _.get(state, 'profile.verifications.amlPending')
  },

  hasAmlPassed (state) {
    return _.get(state, 'profile.verifications.amlPassed')
  },

  hasAmlFailed (state) {
    return _.get(state, 'profile.verifications.amlFailed')
  },

  hasFailedAppropriateness (state) {
    const { appropriatenessFailed } = state.auth.profile.verifications || {}

    return appropriatenessFailed
  },

  hasPassedAppropriateness (state) {
    const { appropriatenessPassed } = state.auth.profile.verifications || {}

    return appropriatenessPassed
  },

  hasApprovedKyc (state) {
    const { authenticated, profile } = state
    const { identityProvided, identityVerified } = profile.verifications || {}

    if (authenticated && identityProvided && identityVerified) {
      return true
    }

    return false
  },

  hasProcessingKyc (state) {
    const { authenticated, profile } = state
    const { identityProvided, identityRejected, identityVerified } = profile.verifications || {}

    if (authenticated && identityProvided && !identityRejected && !identityVerified) {
      return true
    }

    return false
  },

  hasRejectedKyc (state) {
    const { authenticated, profile } = state
    const { identityRejected } = profile.verifications || {}

    if (authenticated && identityRejected) {
      return true
    }

    return false
  },

  hasSubmittedKyc (state) {
    const { authenticated, profile } = state
    const { identityProvided } = profile.verifications || {}

    if (authenticated && identityProvided) {
      return true
    }

    return false
  },

  hasVerifiedEmail (state) {
    const { emailVerified } = state.auth.profile.verifications || {}

    return emailVerified
  },

  name (state) {
    const {
      firstName, lastName, company, isCompany
    } = state.auth.profile

    if (isCompany) {
      return company
    }

    return `${firstName} ${lastName}`
  }
}

export default getters
